'use strict';

module.exports = {
    admin: 'admin',
    supervisor: 'supervisor',
    mobileUser: 'mobileUser',
    everyone: '$everyone',
    owner: 'owner',
    siteAdmin: 'siteAdmin'
};
